import React, { useEffect, useState, createElement } from 'react';
import { ArrowRight, Check, ChevronDown, ChevronUp, ChevronLeft, ChevronRight, ShieldCheck, Star, Sparkles, Gift, BookOpenIcon, XCircleIcon, HeartCrackIcon, BrainCircuitIcon, BatteryLowIcon, Menu, X, Infinity } from 'lucide-react';
import { PurchasePopup } from '../components/PurchasePopup';
import { motion, AnimatePresence } from 'framer-motion';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/7nPndHGtXQWUB6zNSQWrm2/ChatGPT_Image_20_feb_2026,_10_19_25_p.m..png';
const GARANTIA_URL = 'https://cdn.magicpatterns.com/uploads/kAteJP3bb9bJE6XSrARb78/ChatGPT_Image_20_ene_2026,_06_41_42_p.m..png';
const CHECKOUT_URL = 'https://checkout.infinita-mente.online/checkouts/cn/hWN8yUnFUR2ZXFkzeuHhMT2n/es-ar?_r=AQABaXBKWF-VXnWgSte_hXBCAwLDmzPjZmuS6veYAjCiHIw&preview_theme_id=138558668898:1';
const PREVIEW_IMAGES = ['https://cdn.magicpatterns.com/uploads/kA9AhKyAhgppXbMG5M1GcN/Captura_de_pantalla_2026-02-18_195710.png', 'https://cdn.magicpatterns.com/uploads/osb26seU7AZhA833551cXy/Captura_de_pantalla_2026-02-18_195719.png', 'https://cdn.magicpatterns.com/uploads/pJq4MEGJGT3MuukhrQwj1L/Captura_de_pantalla_2026-02-18_195724.png', 'https://cdn.magicpatterns.com/uploads/5x5V4dGVUJX8WZZxgtCEyA/Captura_de_pantalla_2026-02-18_195730.png', 'https://cdn.magicpatterns.com/uploads/a4SvmBRWJd8CVtDw4DqKUn/Captura_de_pantalla_2026-02-18_195734.png'];
const TESTIMONIOS = [{
  nombre: 'Sofía M.',
  edad: '34 años',
  ciudad: 'Buenos Aires',
  texto: 'Por primera vez entendí que el problema no era el dulce. Bajé 3kg sin sentir que estaba a dieta.',
  tiempo: 'hace 2 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/tPTzs7apBCJbBtXaeM5ZwZ/WhatsApp_Image_2026-01-20_at_20.39.50_(2).jpg'
}, {
  nombre: 'Laura P.',
  edad: '41 años',
  ciudad: 'Córdoba',
  texto: 'Dejé de sentir culpa y empecé a ordenar mi relación con la comida. Esto es lo que necesitaba.',
  tiempo: 'hace 1 semana',
  avatar: 'https://cdn.magicpatterns.com/uploads/vTTqwFVTYky9x11D3XA3cw/WhatsApp_Image_2026-01-20_at_20.39.50_(1).jpg'
}, {
  nombre: 'Carolina R.',
  edad: '29 años',
  ciudad: 'Rosario',
  texto: 'No me sentí a dieta. Me sentí acompañada. Y eso cambió todo.',
  tiempo: 'hace 3 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/uuKswkgBJUqfgTssz3gNBQ/WhatsApp_Image_2026-01-20_at_20.39.50.jpg'
}, {
  nombre: 'Mariana G.',
  edad: '38 años',
  ciudad: 'Mendoza',
  texto: 'Lo que más me gustó fue entender el tema de la ansiedad. Ahora sé cómo manejarlo sin prohibirme nada.',
  tiempo: 'hace 5 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/pXB74e6MhmUhKCA3KNE4Bf/WhatsApp_Image_2026-01-20_at_20.39.49.jpg'
}];
const FAQS = [{
  q: '¿Es una dieta?',
  a: 'No. Es un método realista que te enseña a integrar dulces sin culpa y a organizarte mejor. Sin prohibiciones ni exigencias irreales.'
}, {
  q: '¿Qué pasa si fallo?',
  a: 'El método incluye protocolos específicos para esos momentos. No se trata de perfección, sino de saber cómo retomar sin castigarte.'
}, {
  q: '¿Necesito fuerza de voluntad?',
  a: 'No. Necesitás un marco claro. El método te da estructura, no exigencias. La claridad reemplaza la fuerza de voluntad.'
}, {
  q: '¿Cuándo veo resultados?',
  a: 'Muchas mujeres notan cambios en su relación con la comida desde la primera semana. Los cambios físicos dependen de cada organismo, pero la paz mental es inmediata.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'El acceso es 100% digital e inmediato. Una vez realizada la compra, recibirás un correo con todos los accesos para descargar el material.'
}];
export function LandingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    hours: 11,
    minutes: 59,
    seconds: 0
  });
  const [currentPreview, setCurrentPreview] = useState(0);
  const nextPreview = () => {
    setCurrentPreview(prev => (prev + 1) % PREVIEW_IMAGES.length);
  };
  const prevPreview = () => {
    setCurrentPreview(prev => (prev - 1 + PREVIEW_IMAGES.length) % PREVIEW_IMAGES.length);
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          hours: prev.hours,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1934048370513297');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1934048370513297&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  const scrollToPurchase = () => {
    const el = document.getElementById('compra');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
    setIsMenuOpen(false);
  };
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
    setIsMenuOpen(false);
  };
  return <div className="min-h-screen bg-[#0B0510] text-slate-300 font-sans selection:bg-purple-500/30 overflow-x-hidden relative" data-id="element-12">
      {/* Background Glowing Orbs */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-13">
        <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-purple-900/20 blur-[120px]" data-id="element-14" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] rounded-full bg-cyan-900/10 blur-[120px]" data-id="element-15" />
        <div className="absolute top-[40%] left-[60%] w-[30vw] h-[30vw] rounded-full bg-pink-900/10 blur-[100px]" data-id="element-16" />
      </div>

      <div className="relative z-10" data-id="element-17">
        <PurchasePopup data-id="element-18" />

        {/* ─── BRAND BAR ─── */}
        <div className="bg-[#050208] text-white py-2 px-4 flex items-center justify-center gap-2 text-sm font-extrabold tracking-tight border-b border-white/5 relative z-50" data-id="element-19">
          <Infinity className="w-4 h-4 text-cyan-400" data-id="element-20" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400" data-id="element-21">
            InfinitaMenteDigital
          </span>
          <BrainCircuitIcon className="w-4 h-4 text-pink-400" data-id="element-22" />
        </div>

        {/* ─── 1. URGENCY BAR ─── */}
        <div className="bg-gradient-to-r from-purple-900/80 via-pink-900/80 to-purple-900/80 backdrop-blur-md border-b border-white/10 text-white py-2 px-4 text-center font-medium sticky top-0 z-50" data-id="element-23">
          <div className="flex items-center justify-center gap-2 text-xs" data-id="element-24">
            <span data-id="element-25">⏳ Oferta especial termina en</span>
            <div className="flex gap-1" data-id="element-26">
              <span className="bg-black/30 px-2 py-0.5 rounded text-[10px] font-semibold border border-white/10" data-id="element-27">
                {String(timeLeft.hours).padStart(2, '0')}h
              </span>
              <span className="bg-black/30 px-2 py-0.5 rounded text-[10px] font-semibold border border-white/10" data-id="element-28">
                {String(timeLeft.minutes).padStart(2, '0')}m
              </span>
              <span className="bg-black/30 px-2 py-0.5 rounded text-[10px] font-semibold border border-white/10" data-id="element-29">
                {String(timeLeft.seconds).padStart(2, '0')}s
              </span>
            </div>
          </div>
        </div>

        {/* ─── NAVIGATION ─── */}
        <nav className="sticky top-[32px] z-40 w-full px-4 py-4" data-id="element-30">
          <div className="max-w-6xl mx-auto bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl px-6 py-3 flex items-center justify-between shadow-2xl" data-id="element-31">
            <div className="font-light text-white tracking-widest flex items-center gap-2 text-[16px]" data-id="element-32">
              <Sparkles className="w-4 h-4 text-pink-400" data-id="element-33" />
              MEGAPACK VOLVER A COMER EN PAZ
            </div>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-6" data-id="element-34">
              <button onClick={() => scrollToSection('problema')} className="text-xs font-light tracking-wide hover:text-white transition-colors" data-id="element-35">
                El Problema
              </button>
              <button onClick={() => scrollToSection('metodo')} className="text-xs font-light tracking-wide hover:text-white transition-colors" data-id="element-36">
                El Método
              </button>
              <button onClick={() => scrollToSection('beneficios')} className="text-xs font-light tracking-wide hover:text-white transition-colors" data-id="element-37">
                Beneficios
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="text-xs font-light tracking-wide hover:text-white transition-colors" data-id="element-38">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-xs font-light tracking-wide hover:text-white transition-colors" data-id="element-39">
                FAQs
              </button>
            </div>

            <div className="hidden md:block" data-id="element-40">
              <button onClick={scrollToPurchase} className="bg-emerald-500/20 hover:bg-emerald-500/30 border border-emerald-500/30 text-emerald-300 text-xs font-light py-2 px-5 rounded-full transition-all tracking-wide" data-id="element-41">
                Acceder al Producto
              </button>
            </div>

            {/* Mobile Nav Toggle */}
            <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-42">
              {isMenuOpen ? <X className="w-5 h-5" strokeWidth={1.5} data-id="element-43" /> : <Menu className="w-5 h-5" strokeWidth={1.5} data-id="element-44" />}
            </button>
          </div>

          {/* Mobile Menu */}
          <AnimatePresence data-id="element-45">
            {isMenuOpen && <motion.div initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} className="absolute top-full left-4 right-4 mt-2 bg-[#1A0B2E]/95 backdrop-blur-xl border border-white/10 rounded-2xl p-4 flex flex-col gap-4 shadow-2xl md:hidden" data-id="element-46">
                <button onClick={() => scrollToSection('problema')} className="text-left text-sm font-light p-2 hover:bg-white/5 rounded-lg tracking-wide" data-id="element-47">
                  El Problema
                </button>
                <button onClick={() => scrollToSection('metodo')} className="text-left text-sm font-light p-2 hover:bg-white/5 rounded-lg tracking-wide" data-id="element-48">
                  El Método
                </button>
                <button onClick={() => scrollToSection('beneficios')} className="text-left text-sm font-light p-2 hover:bg-white/5 rounded-lg tracking-wide" data-id="element-49">
                  Beneficios
                </button>
                <button onClick={() => scrollToSection('testimonios')} className="text-left text-sm font-light p-2 hover:bg-white/5 rounded-lg tracking-wide" data-id="element-50">
                  Testimonios
                </button>
                <button onClick={() => scrollToSection('faq')} className="text-left text-sm font-light p-2 hover:bg-white/5 rounded-lg tracking-wide" data-id="element-51">
                  FAQs
                </button>
                <button onClick={scrollToPurchase} className="bg-emerald-500 hover:bg-emerald-400 text-white text-sm font-medium py-3 px-6 rounded-xl mt-2 transition-colors" data-id="element-52">
                  Acceder al Producto
                </button>
              </motion.div>}
          </AnimatePresence>
        </nav>

        {/* ─── HERO ─── */}
        <section className="relative px-4 pt-12 pb-20 lg:min-h-[85vh] flex items-center justify-center text-center" data-id="element-53">
          <div className="max-w-4xl mx-auto flex flex-col items-center gap-6 z-10" data-id="element-54">
            <h1 className="md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight text-[28px] mt-[-50px] mb-[-50px]" data-id="element-55">
              Todo lo que necesitás para disfrutar la comida sin culpa, <br data-id="element-56" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400" data-id="element-57">
                sin dietas eternas y con hábitos reales.
              </span>
            </h1>

            <div className="relative flex justify-center w-full max-w-lg mx-auto -mt-2 -mb-2" data-id="element-58">
              <div className="absolute inset-0 bg-gradient-to-tr from-purple-500/20 to-pink-500/20 blur-3xl rounded-full" data-id="element-59" />
              <motion.img src={MOCKUP_URL} alt="MegaPack Volver a Comer en Paz" className="w-full drop-shadow-[0_0_50px_rgba(236,72,153,0.3)] relative z-10 mt-[-120px] mb-[-120px]" animate={{
              y: [0, -18, 0, -8, 0],
              rotateZ: [0, -1.5, 0, 1.5, 0],
              rotateY: [0, 3, 0, -3, 0],
              scale: [1, 1.02, 1, 1.01, 1]
            }} transition={{
              duration: 6,
              repeat: Infinity,
              ease: 'easeInOut',
              times: [0, 0.25, 0.5, 0.75, 1]
            }} whileHover={{
              scale: 1.05,
              rotateY: 8,
              transition: {
                duration: 0.4,
                ease: 'easeOut'
              }
            }} style={{
              perspective: 800
            }} data-id="element-60" />
            </div>

            <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 text-pink-300 px-4 py-1 rounded-full text-[10px] md:text-xs font-medium tracking-widest -mt-2" data-id="element-61">
              <Sparkles className="w-3 h-3" data-id="element-62" />
              EDICIÓN COMPLETA · ACCESO DE POR VIDA
            </div>

            <p className="text-lg md:text-xl text-slate-400 max-w-2xl leading-relaxed" data-id="element-63">
              Todo lo que necesitás para disfrutar la comida sin culpa, sin
              dietas eternas y con hábitos reales.
            </p>

            <button onClick={scrollToPurchase} className="bg-emerald-500 text-white hover:bg-emerald-400 text-lg font-bold py-4 px-8 rounded-full shadow-[0_0_40px_rgba(16,185,129,0.4)] transform transition hover:scale-105 flex items-center gap-2 mt-4" data-id="element-64">
              Quiero empezar ahora
              <ArrowRight className="w-5 h-5" data-id="element-65" />
            </button>
          </div>
        </section>

        {/* ─── ALTERNATING SECTION 1: PAIN POINTS ─── */}
        <section id="problema" className="py-20 px-4 relative" data-id="element-66">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center" data-id="element-67">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="order-2 lg:order-1 relative" data-id="element-68">
              <div className="aspect-square rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-8 flex flex-col justify-center gap-6 relative overflow-hidden" data-id="element-69">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-pink-500 to-purple-500" data-id="element-70" />
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-71">
                  El ciclo eterno:
                </h3>

                <div className="space-y-4" data-id="element-72">
                  {['Restricción extrema', 'Ansiedad incontrolable', 'Culpa paralizante', 'Volver a empezar'].map((step, i) => <div key={i} className="flex items-center gap-4 bg-black/40 p-4 rounded-xl border border-white/5" data-id="element-73">
                      <div className="w-8 h-8 rounded-full bg-pink-500/20 text-pink-400 flex items-center justify-center font-bold text-sm" data-id="element-74">
                        {i + 1}
                      </div>
                      <span className="text-slate-300 font-medium" data-id="element-75">{step}</span>
                    </div>)}
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="order-1 lg:order-2 flex flex-col gap-6" data-id="element-76">
              <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-77">
                El problema no sos vos. <br data-id="element-78" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500" data-id="element-79">
                  Es el enfoque.
                </span>
              </h2>
              <p className="text-lg text-slate-400 leading-relaxed" data-id="element-80">
                Te hicieron creer que para verte bien tenés que sufrir. Que
                comer algo dulce es fracasar. Que si no lo hacés perfecto, no
                sirve.
              </p>
              <p className="text-lg text-slate-400 leading-relaxed" data-id="element-81">
                Esto no es falta de disciplina. Es un sistema que no funciona en
                la vida real.
              </p>
            </motion.div>
          </div>
        </section>

        {/* ─── ALTERNATING SECTION 2: TRANSFORMATION ─── */}
        <section id="beneficios" className="py-20 px-4 relative" data-id="element-82">
          <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-83">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="flex flex-col items-center gap-6" data-id="element-84">
              <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-85">
                Cómo se va a sentir tu vida con el <br data-id="element-86" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-500" data-id="element-87">
                  MegaPack Volver a Comer en Paz
                </span>
              </h2>
              <div className="space-y-4 mt-4 text-left" data-id="element-88">
                {['Vas a poder comer algo dulce sin sabotearte', 'Vas a dejar de odiarte después de un desliz', 'Vas a sentir claridad en vez de culpa', 'Vas a dejar de empezar de cero cada semana'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-89">
                    <div className="bg-purple-500/20 p-1 rounded-full" data-id="element-90">
                      <Check className="w-4 h-4 text-purple-400" data-id="element-91" />
                    </div>
                    <p className="text-lg text-slate-300" data-id="element-92">{item}</p>
                  </div>)}
              </div>
            </motion.div>
          </div>
        </section>

        {/* ─── METHOD PREVIEW CAROUSEL ─── */}
        <section id="metodo" className="py-20 px-4 relative" data-id="element-93">
          <div className="max-w-4xl mx-auto text-center" data-id="element-94">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-95">
              El Método por dentro
            </h2>
            <p className="text-lg text-slate-400 mb-12" data-id="element-96">
              Un sistema práctico y amable que te enseña a tomar decisiones
              desde la claridad.
            </p>

            <div className="relative bg-white/5 border border-white/10 rounded-3xl p-4 md:p-8 backdrop-blur-xl shadow-2xl" data-id="element-97">
              <div className="overflow-hidden rounded-2xl border border-white/10 bg-black/50" data-id="element-98">
                <AnimatePresence mode="wait" data-id="element-99">
                  <motion.img key={currentPreview} src={PREVIEW_IMAGES[currentPreview]} alt={`Vista previa ${currentPreview + 1}`} className="w-full h-auto" initial={{
                  opacity: 0,
                  scale: 0.95
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} exit={{
                  opacity: 0,
                  scale: 1.05
                }} transition={{
                  duration: 0.4
                }} data-id="element-100" />
                </AnimatePresence>
              </div>

              <button onClick={prevPreview} className="absolute left-0 md:-left-6 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 border border-white/20 text-white p-3 rounded-full backdrop-blur-md transition-all" data-id="element-101">
                <ChevronLeft className="w-6 h-6" data-id="element-102" />
              </button>
              <button onClick={nextPreview} className="absolute right-0 md:-right-6 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 border border-white/20 text-white p-3 rounded-full backdrop-blur-md transition-all" data-id="element-103">
                <ChevronRight className="w-6 h-6" data-id="element-104" />
              </button>

              <div className="flex justify-center gap-3 mt-6" data-id="element-105">
                {PREVIEW_IMAGES.map((_, i) => <button key={i} onClick={() => setCurrentPreview(i)} className={`w-3 h-3 rounded-full transition-all ${i === currentPreview ? 'bg-pink-500 scale-125' : 'bg-white/20 hover:bg-white/40'}`} data-id="element-106" />)}
              </div>
            </div>
          </div>
        </section>

        {/* ─── WHAT'S INCLUDED ─── */}
        <section className="py-20 px-4 relative" data-id="element-107">
          <div className="max-w-6xl mx-auto" data-id="element-108">
            <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-16" data-id="element-109">
              Todo lo que incluye
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-110">
              {/* Tomos */}
              <div className="bg-white/5 border border-white/10 rounded-3xl p-8 backdrop-blur-md" data-id="element-111">
                <div className="flex items-center gap-3 mb-8" data-id="element-112">
                  <BookOpenIcon className="w-8 h-8 text-cyan-400" data-id="element-113" />
                  <h3 className="text-2xl font-bold text-white" data-id="element-114">
                    8 Tomos Paso a Paso
                  </h3>
                </div>
                <div className="space-y-4" data-id="element-115">
                  {['El problema nunca fue el dulce', 'Comidas reales para una vida real', 'Movimiento sin castigo', 'Hábitos que no te rompen', 'Elegir sin sabotearte', 'Sostener sin castigarte', 'Cuidarte en un mundo que no para', 'Habitar tu vida sin castigo'].map((tomo, i) => <div key={i} className="flex items-center gap-4 bg-black/30 p-4 rounded-xl border border-white/5" data-id="element-116">
                      <span className="text-cyan-400 font-bold" data-id="element-117">0{i + 1}</span>
                      <span className="text-slate-300" data-id="element-118">{tomo}</span>
                    </div>)}
                </div>
              </div>

              {/* Bonos */}
              <div className="bg-gradient-to-b from-pink-900/20 to-purple-900/20 border border-pink-500/20 rounded-3xl p-8 backdrop-blur-md" data-id="element-119">
                <div className="flex items-center gap-3 mb-8" data-id="element-120">
                  <Gift className="w-8 h-8 text-pink-400" data-id="element-121" />
                  <h3 className="text-2xl font-bold text-white" data-id="element-122">
                    4 Bonos Exclusivos
                  </h3>
                </div>
                <div className="space-y-4" data-id="element-123">
                  {[{
                  title: 'Dulces sin culpa',
                  desc: 'Recetas y estrategias'
                }, {
                  title: 'Reorden sin culpa',
                  desc: 'Cómo retomar después de un día difícil'
                }, {
                  title: 'Protocolos antisabotaje',
                  desc: 'Herramientas para momentos difíciles'
                }, {
                  title: 'Mínimos sostenibles',
                  desc: 'Lo mínimo para no perder el rumbo'
                }].map((bono, i) => <div key={i} className="bg-black/40 p-5 rounded-xl border border-pink-500/10" data-id="element-124">
                      <h4 className="text-white font-bold mb-1" data-id="element-125">
                        {bono.title}
                      </h4>
                      <p className="text-sm text-slate-400" data-id="element-126">{bono.desc}</p>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ─── TESTIMONIALS ─── */}
        <section id="testimonios" className="py-20 px-4 relative" data-id="element-127">
          <div className="max-w-6xl mx-auto" data-id="element-128">
            <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-16" data-id="element-129">
              Lo que dicen otras mujeres
            </h2>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-130">
              {TESTIMONIOS.map((t, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-md flex flex-col justify-between" data-id="element-131">
                  <p className="text-lg text-slate-300 italic mb-6" data-id="element-132">
                    "{t.texto}"
                  </p>
                  <div className="flex items-center gap-4" data-id="element-133">
                    <img src={t.avatar} alt={t.nombre} className="w-12 h-12 rounded-full border-2 border-white/20 object-cover" data-id="element-134" />
                    <div data-id="element-135">
                      <p className="text-white font-bold" data-id="element-136">{t.nombre}</p>
                      <p className="text-xs text-slate-400" data-id="element-137">
                        {t.edad}, {t.ciudad}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* ─── PRICING / CHECKOUT ─── */}
        <section id="compra" className="py-16 px-4 relative" data-id="element-138">
          {/* Section background glow */}
          <div className="absolute inset-0 bg-gradient-to-b from-pink-900/10 via-purple-900/15 to-pink-900/10 pointer-events-none" data-id="element-139" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[60vh] bg-pink-500/8 blur-[150px] rounded-full pointer-events-none" data-id="element-140" />

          <div className="max-w-2xl mx-auto relative z-10" data-id="element-141">
            <div className="relative bg-gradient-to-b from-white/[0.12] to-white/[0.04] border-2 border-pink-500/30 rounded-[2rem] p-6 md:p-10 backdrop-blur-xl shadow-[0_0_100px_rgba(236,72,153,0.25),0_0_40px_rgba(168,85,247,0.15)] overflow-hidden mt-[0px] mb-[0px]" data-id="element-142">
              {/* Decorative elements */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[2px] bg-gradient-to-r from-transparent via-pink-500 to-transparent" data-id="element-143" />
              <div className="absolute -top-20 -right-20 w-40 h-40 bg-pink-500/40 blur-3xl rounded-full pointer-events-none" data-id="element-144" />
              <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-purple-500/40 blur-3xl rounded-full pointer-events-none" data-id="element-145" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-pink-500/10 blur-[80px] rounded-full pointer-events-none" data-id="element-146" />

              <div className="relative z-10 flex flex-col items-center" data-id="element-147">
                <span className="bg-pink-500/20 border border-pink-500/30 text-pink-300 px-5 py-1.5 rounded-full text-xs font-bold tracking-widest mb-3" data-id="element-148">
                  🔥 PRECIO DE LANZAMIENTO
                </span>

                <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-2" data-id="element-149">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-purple-400 to-cyan-400" data-id="element-150">
                    MegaPack Volver a Comer en Paz
                  </span>
                </h3>

                <div className="relative w-full flex justify-center mb-2" data-id="element-151">
                  <div className="absolute inset-0 bg-gradient-to-tr from-pink-500/15 to-purple-500/15 blur-3xl rounded-full" data-id="element-152" />
                  <img src={MOCKUP_URL} alt="MegaPack Volver a Comer en Paz" className="w-full max-w-sm drop-shadow-[0_0_60px_rgba(236,72,153,0.35)] relative z-10 pt-[0px] pb-[0px] mt-[-50px] mb-[-50px]" data-id="element-153" />
                </div>
                <p className="text-slate-400 text-center text-sm mb-6" data-id="element-154">
                  Todo lo que necesitás para disfrutar la comida sin culpa, sin
                  dietas eternas y con hábitos reales.
                </p>

                <div className="text-center mb-6" data-id="element-155">
                  <span className="text-slate-500 line-through text-lg" data-id="element-156">
                    $66.999
                  </span>
                  <div className="text-5xl md:text-6xl font-extrabold text-white my-1.5 tracking-tight" data-id="element-157">
                    $14.999
                  </div>
                  <span className="inline-block bg-green-500/20 border border-green-500/30 text-green-400 font-bold text-xs px-4 py-1.5 rounded-full" data-id="element-158">
                    77% OFF · Ahorrás $52.000
                  </span>
                </div>

                <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="w-full max-w-sm bg-emerald-500 text-white hover:bg-emerald-400 text-lg font-bold py-4 rounded-2xl shadow-[0_0_50px_rgba(16,185,129,0.3)] transform transition hover:scale-[1.02] flex items-center justify-center gap-2 mb-5" data-id="element-159">
                  Quiero empezar hoy
                  <ArrowRight className="w-5 h-5" data-id="element-160" />
                </a>

                <div className="flex flex-col items-center gap-2" data-id="element-161">
                  <img src={GARANTIA_URL} alt="Garantía" className="w-20 opacity-80" data-id="element-162" />
                  <p className="text-xs text-slate-400 text-center max-w-xs" data-id="element-163">
                    Probá el método durante 7 días. Si no es para vos, te
                    devolvemos el dinero.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ─── FAQ ─── */}
        <section id="faq" className="py-20 px-4 relative" data-id="element-164">
          <div className="max-w-3xl mx-auto" data-id="element-165">
            <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-12" data-id="element-166">
              Preguntas Frecuentes
            </h2>
            <div className="space-y-4" data-id="element-167">
              {FAQS.map((faq, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden backdrop-blur-md" data-id="element-168">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-169">
                    <span className="font-bold text-white text-lg pr-4" data-id="element-170">
                      {faq.q}
                    </span>
                    {openFaq === i ? <ChevronUp className="w-5 h-5 text-pink-400 flex-shrink-0" data-id="element-171" /> : <ChevronDown className="w-5 h-5 text-slate-500 flex-shrink-0" data-id="element-172" />}
                  </button>
                  <AnimatePresence data-id="element-173">
                    {openFaq === i && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} className="overflow-hidden" data-id="element-174">
                        <div className="px-6 pb-6 text-slate-300 leading-relaxed border-t border-white/10 pt-4" data-id="element-175">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
            </div>
          </div>
        </section>

        {/* ─── FOOTER ─── */}
        <footer className="border-t border-white/10 py-12 px-4 text-center mt-20" data-id="element-176">
          <div className="flex items-center justify-center gap-2 text-slate-400 mb-4" data-id="element-177">
            <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-178" />
            <span data-id="element-179">Compra 100% Segura · Garantía de 7 días</span>
          </div>
          <p className="text-slate-600 text-sm" data-id="element-180">
            © {new Date().getFullYear()} Infinitamente. Todos los derechos
            reservados.
          </p>
        </footer>
      </div>
    </div>;
}